import { FilterDropdown } from 'components/tailwind-ui/FilterDropdown';
import { PresetView } from 'pages/Shipments/Containers/types';
import { useFilterSearchParams } from 'pages/Shipments/Containers/utilities';
import * as React from 'react';
import { CurrentContainerStatus } from 'types/Watchlist';
import { StatusEntry } from './StatusEntry';

const StatusEntries: CurrentContainerStatus[] = [
  CurrentContainerStatus.Manifested,
  CurrentContainerStatus.OnVessel,
  CurrentContainerStatus.AtTerminal,
  CurrentContainerStatus.GatedOut,
  CurrentContainerStatus.Terminated,
  CurrentContainerStatus.OffRail,
  CurrentContainerStatus.OnRail,
  CurrentContainerStatus.GateOutFromRailFacility,
];

interface Props {
  presetView: PresetView;
}

export const StatusFilter: React.FC<Props> = (props) => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);
  const { presetView } = props;

  const filterStates: CurrentContainerStatus[] = React.useMemo(() => {
    const filters: CurrentContainerStatus[] = [];
    searchParams.containerStatus.forEach((s: string) => {
      const entry = StatusEntries.find((e) => e === s);
      if (entry) {
        filters.push(entry);
      }
    });
    return filters;
  }, [searchParams]);

  const handleOnChange = (status: CurrentContainerStatus, v: boolean) => {
    let newFilterStates = [...filterStates];

    if (v) {
      newFilterStates.push(status);
    } else {
      newFilterStates = newFilterStates.filter((s: CurrentContainerStatus) => s !== status);
    }

    setSearchParams({
      containerStatus: StatusEntries.filter((e) => newFilterStates.includes(e)).flatMap(
        (e) => e ?? []
      ),
    });
  };

  return (
    <FilterDropdown
      label="Status"
      count={filterStates.length}
      clear={() => setSearchParams({ importStatus: [], containerStatus: [] })}
    >
      {StatusEntries.map((entry) => (
        <StatusEntry
          key={entry}
          status={entry}
          checked={filterStates.includes(entry)}
          onChange={handleOnChange}
          presetView={presetView}
        />
      ))}
    </FilterDropdown>
  );
};
StatusFilter.displayName = 'Shipments.Filters.Status';
